<template>
  <div class="simul">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <div class="is-flex is-justify-content-space-between" v-if="!isLoading">
      <router-link to="/lobby">
        <a class="is-size-4 has-text-link">&lt;&lt; Lobby</a>
      </router-link>
      <router-link
        to="/simuls/new"
        v-if="permission.admin || permission.hostSimul"
      >
        <a class="is-size-4 has-text-link">Create a simul &gt;&gt;</a>
      </router-link>
    </div>

    <div v-if="mySimulsFiltered.length">
      <div class="is-flex is-flex-direction-column">
        <p class="has-text-left is-size-4 mt-4 mb-2 has-text-success-dark">
          You're the host ({{ mySimulsFiltered.length }})
        </p>

        <div class="is-flex mb-4">
          <span class="has-text-info mr-4">Filter by status:</span>
          <b-checkbox v-model="mySimulsFilterStatuses" native-value="created">
            Open
          </b-checkbox>
          <b-checkbox v-model="mySimulsFilterStatuses" native-value="started">
            Playing
          </b-checkbox>
          <b-checkbox v-model="mySimulsFilterStatuses" native-value="finished">
            Ended
          </b-checkbox>
        </div>
      </div>
      <SimulTable :simuls="mySimulsFiltered" />
    </div>

    <p class="has-text-left is-size-4 mt-5 mb-4 has-text-success-dark">
      Open simuls ({{ openSimuls.length }})
    </p>
    <SimulTable :simuls="openSimuls" />

    <p class="has-text-left is-size-4 mt-5 mb-4 has-text-success-dark">
      Playing simuls ({{ playingSimuls.length }})
    </p>
    <SimulTable :simuls="playingSimuls" />

    <b-button
      class="mt-6"
      @click="showFinished()"
      :label="
        showFinishedSimuls ? 'Hide finished simuls' : 'Show finished simuls'
      "
    ></b-button>

    <div v-if="showFinishedSimuls">
      <p class="has-text-left is-size-4 mt-4 has-text-success-dark">
        Finished simuls ({{ finishedSimuls.length }})
      </p>
      <SimulTable :simuls="finishedSimuls" />
    </div>
  </div>
</template>

<script>
import { SIMUL_STATUS } from "vue-chess-shared/constants";
import SimulTable from "@/components/simuls/SimulTable.vue";
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

const simuls = firestore.collection("simuls");

export default {
  components: { SimulTable },

  name: "Simuls",

  title() {
    return "Simuls";
  },

  data() {
    return {
      isLoading: true,
      mySimulsFilterStatuses: [SIMUL_STATUS.CREATED, SIMUL_STATUS.STARTED],
      showFinishedSimuls: false,
      mySimuls: [],
      otherSimuls: [],
      finishedSimuls: [],
    };
  },

  computed: {
    ...mapGetters({
      currentProfile: "getProfile",
      currentPlayer: "getPlayer",
      permission: "getPermission",
    }),

    mySimulsFiltered() {
      return this.mySimuls.filter((s) =>
        this.mySimulsFilterStatuses.includes(s.status)
      );
    },
    openSimuls() {
      return this.otherSimuls.filter((s) => s.status === SIMUL_STATUS.CREATED);
    },
    playingSimuls() {
      return this.otherSimuls.filter((s) => s.status === SIMUL_STATUS.STARTED);
    },
  },

  watch: {
    currentPlayer: {
      immediate: true,
      async handler() {
        if (!this.currentPlayer) return;
        this.isLoading = true;

        const userId = this.$route.query.u
          ? this.$route.query.u
          : this.currentPlayer.user_id;

        await this.$bind("mySimuls", simuls.where("userId", "==", userId));
        await this.$bind(
          "otherSimuls",
          simuls.where("userId", "!=", this.currentPlayer.user_id)
        );
        await this.$bind(
          "finishedSimuls",
          simuls.where("status", "==", SIMUL_STATUS.FINISHED).limit(50)
        );

        this.isLoading = false;
      },
    },
  },

  methods: {
    showFinished() {
      this.showFinishedSimuls = !this.showFinishedSimuls;
    },
  },
};
</script>

<style scoped></style>
